import { call, put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {insertUserAPI, loginUserAPI} from '../api/userAPI'
import {USER} from '../actions/user';
import UserConverter from '../models/user/userConverter';
import UserController from '../models/user/userController';
import {USER_LOGIN} from 'admin-on-rest';


/*************************** CALLS ***************************/

export function* insertUserCall(action) {
  try {
    const data = UserConverter.toAPIRegisterUSer(action.payload.data);
    const response = yield call(insertUserAPI, data, 0);
    UserController._setLoggedInUserToLocalStorage(response);
    yield put(push('/'));
  }
  catch (error) {
    console.info("[saga.user insert] error: ", error);
    yield put({type: USER.INSERT_FAILED});
  }
}

export function* loginUserCall(action) {
  
  yield put({ type: USER.LOGIN_SUCCESS_RESET });
  
  try {
    
    let response = yield loginUserAPI(action.payload);
    if(response) {
      UserController._setLoggedInUserToLocalStorage(response);
      yield put({ type: USER.LOGIN_SUCCESS });
      yield put(push('/'));
    }
    else {
      yield put({ type: USER.LOGIN_FAILED });
    }
  }
  catch (error) {
    console.info("[auth.saga login] error: ", error);
    yield put({ type: USER.LOGIN_FAILED });
  }
}


/*************************** WATCH ***************************/

export function* insertUserWatch() {
  yield takeEvery(USER.SET, insertUserCall);
}

export function* loginUserWatch() {
  yield takeEvery(USER_LOGIN, loginUserCall);
}


// WEBPACK FOOTER //
// ./src/sagas/user.js